import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import apiFetch from "../../Api";

const MyExamsPage = () => {
    const [exams, setExams] = useState([]);
    const [message, setMessage] = useState({ type: '', text: '' });

    useEffect(() => {
        const fetchMyExams = async () => {
            try {
                const response = await apiFetch('/api/my-exams');
                const data = await response.json();

                if (response.ok) {
                    setExams(data);
                } else {
                    setMessage({ type: 'error-message', text: data.errorMessage || 'Nie udało się pobrać Twoich egzaminów.' });
                }
            } catch (error) {
                console.error('Błąd podczas pobierania egzaminów:', error);
                setMessage({ type: 'error-message', text: 'Wystąpił błąd sieci lub serwera.' });
            }
        };

        fetchMyExams();
    }, []);

    // Funkcja pomocnicza do formatowania daty
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleString('pl-PL', { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
    };

    return (
        <div>
            <div className="container">
                {message.text && (
                    <div className={`message ${message.type}`}>
                        {message.text}
                    </div>
                )}
                <table>
                    <thead>
                    <tr>
                        <th>Nazwa egzaminu</th>
                        <th>Wynik</th>
                        <th>Data wykonania</th>
                        <th>Akcje</th>
                    </tr>
                    </thead>
                    <tbody>
                    {exams.length > 0 ? (
                        exams.map((exam) => (
                            <tr key={exam.examName}>
                                <td>{exam.examName}</td>
                                <td>{exam.scorePercentage}%</td>
                                <td>{formatDate(exam.submissionTime)}</td>
                                <td>
                                    <Link to={`/exam/result?examName=${encodeURIComponent(exam.examName)}`}>Szczegóły</Link>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="4">Brak ukończonych egzaminów.</td>
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default MyExamsPage;